module.exports = __webpack_public_path__ + "img/site-info.b72c3e78.png";